import { Navigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function RegistrationSuccess() {
  const { t } = useTranslation();
  const location = useLocation();
  const state = location.state || {};
  const firstName = (state.firstName || "").trim();
  const lastName = (state.lastName || "").trim();
  const fullName = `${firstName} ${lastName}`.trim();

  if (!fullName) {
    return <Navigate to="/register" replace />;
  }

  return (
    <div className="content">
      <Header />
      <div className="center-content">
        <div>
          <h1>{t("auth.register.thankYouHeadline", { name: fullName })}</h1>
          <p>{t("auth.register.thankYouText")}</p>
        </div>
      </div>
      <Footer />
    </div>
  );
}
